import { render, staticRenderFns } from "./menu-management.vue?vue&type=template&id=7a61335d&"
import script from "./menu-management.vue?vue&type=script&lang=js&"
export * from "./menu-management.vue?vue&type=script&lang=js&"
import style0 from "./menu-management.vue?vue&type=style&index=0&id=7a61335d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports